//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClientePagador from './ClientePagador';
import AcaoFluxo from './AcaoFluxo';
import StatusPassos from '../../../../../../../shared-components/workflow/StatusPassos';

export default {
  name: 'PendenciaNegociacao',
  components: {
    StatusPassos,
    AcaoFluxo,
    ClientePagador,
  },
  props: {
    pendencia: null,
    ultimaPagina: false,
    exibirAcaoFluxo: true,
  },
  data() {
    return {
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      statusPassos: {},
      showTooltip: false,
      carregou: false,
    };
  },
  watch: {
    showTooltip() {
      if (!this.carregou) {
        setTimeout(() => {
          this.showTooltip = false;
        }, 1E2);
        this.carregou = true;
      }
    },
  },
  methods: {
    irProximaApuracao(irProxima) {
      if (irProxima) {
        setTimeout(() => {
          this.$emit('PendenciaNegociacao_irProximaApuracao');
        }, 5E2);
      }
    },
    requestAbrirAcompanhamento() {
      const id = this.pendencia.id;
      this.workflowPassosResources.statusPassosApuracao({ id }, { id })
        .then((res) => {
          this.statusPassos = res.data;
          this.$refs.modalAcompanhamento.open();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    aprovar(irProxima) {
      const urlParam = { idApuracao: this.pendencia.id };
      const bodyParam = { observacao: this.pendencia.justificativa };
      this.workflowPassosResources.aprovarPassosApuracao(urlParam, bodyParam)
        .then(() => {
          this.pendencia.status = 'APROVADO';
          this.irProximaApuracao(irProxima);
          this.$toast.create(this.$t('message.apuracao_passos_aprovar'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$toast.create(err.data.error, 'snack', 3E3);
        });
    },
    enviarAnalise(irProxima) {
      const urlParam = { idApuracao: this.pendencia.id };
      const bodyParam = { observacao: this.pendencia.justificativa };
      this.workflowPassosResources.enviarApuracaoAnalise(urlParam, bodyParam)
        .then(() => {
          this.pendencia.status = 'EM_ANALISE';
          this.irProximaApuracao(irProxima);
          this.$toast.create(this.$t('message.apuracao_passos_enviar_analise'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$toast.create(err.data.error, 'snack', 3E3);
        });
    },
    reprovar(irProxima) {
      const urlParam = { idApuracao: this.pendencia.id };
      const bodyParam = { observacao: this.pendencia.justificativa };
      this.workflowPassosResources.reprovarPassosApuracao(urlParam, bodyParam)
        .then(() => {
          this.pendencia.status = 'REPROVADO';
          this.irProximaApuracao(irProxima);
          this.$toast.create(this.$t('message.apuracao_passos_reprovar'), 'snack', 3E3);
        })
        .catch((err) => {
          this.$toast.create(err.data.error, 'snack', 3E3);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/PendenciaNegociacao.vue?vue&type=script&lang=js&